import * as React from 'react'
import { useSearchParams } from 'react-router-dom'

export const AdminLogin: React.FC = () => {
  const [searchParams] = useSearchParams()
  const error = searchParams.get('error')

  return (
    <div className="min-h-screen bg-[#294b78] flex items-center justify-center">
      <div className="bg-white rounded-xl shadow-md p-10 max-w-sm w-full text-center">
        <img
          src="/HcmKendoLogo_blue.png"
          alt="HCM Kendo Federation"
          className="h-20 w-20 mx-auto mb-6 object-contain"
        />
        <h1 className="text-2xl font-bold text-[#0d111c] mb-2">Admin Dashboard</h1>
        <p className="text-[#47619e] text-sm mb-8">HCM Kendo Federation</p>

        {error === 'unauthorized' && (
          <div className="bg-red-50 border border-red-200 text-red-700 rounded-lg px-4 py-3 mb-6 text-sm">
            Your Google account is not authorized. Please contact the administrator.
          </div>
        )}

        <a
          href={`${process.env.REACT_APP_API_URL || 'http://localhost:3001'}/api/auth/google`}
          className="flex items-center justify-center gap-3 w-full bg-white border border-gray-300 rounded-lg px-4 py-3 text-sm font-medium text-gray-700 hover:bg-gray-50 transition-colors shadow-sm"
        >
          <svg viewBox="0 0 24 24" className="w-5 h-5">
            <path
              fill="#4285F4"
              d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
            />
            <path
              fill="#34A853"
              d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
            />
            <path
              fill="#FBBC05"
              d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
            />
            <path
              fill="#EA4335"
              d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
            />
          </svg>
          Sign in with Google
        </a>
      </div>
    </div>
  )
}
